import logo_header from '../../Assets/logo_header.png';
import * as S from './footer.styles'

export const Footer = () => {
  return (
    <S.Wrapper id='contact'>
      <S.LogoBox>
        <img
          src={logo_header}
          alt="logo_header"
          className='w-[156px] lg:w-[231px]'
        />
        <S.PLogo>PayQuest (c) 2025</S.PLogo>
      </S.LogoBox>
      <S.ContactBox>
        {/* <S.Paragraph>
          contato@<S.ParagraphSpan>payquest.com.br</S.ParagraphSpan>
        </S.Paragraph>

        <S.Paragraph>
          +55 41<S.ParagraphSpan>99992.0109</S.ParagraphSpan> */}
        {/* </S.Paragraph> */}
      </S.ContactBox>
    </S.Wrapper>
  )
}
